"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetHLQATasks = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_hlqa_tasks_query_1 = require("./get-hlqa-tasks.query");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const useGetHLQATasks = ({ catalogId, productTreeId, filter, sort, pageSize = client_constants_1.PAGE_SIZE_DEFAULT, options, }) => {
    var _a, _b, _c, _d;
    const shouldSkip = !catalogId || !productTreeId;
    const { data, networkStatus, previousData, error, refetch, } = (0, react_2.useQuery)(get_hlqa_tasks_query_1.GET_HLQA_TASKS, {
        variables: {
            catalogId,
            productTreeId,
            filter,
            sort,
            first: pageSize,
            after: null,
            before: null,
        },
        fetchPolicy: (_a = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _a !== void 0 ? _a : 'cache-first',
        nextFetchPolicy: 'cache-first',
        skip: shouldSkip || (options === null || options === void 0 ? void 0 : options.skip),
        notifyOnNetworkStatusChange: true,
    });
    const priorityTasksData = (0, react_1.useMemo)(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.catalog) === null || _a === void 0 ? void 0 : _a.priorityTasks; }, [data]);
    const edges = (0, react_1.useMemo)(() => { var _a; return (_a = priorityTasksData === null || priorityTasksData === void 0 ? void 0 : priorityTasksData.edges) !== null && _a !== void 0 ? _a : []; }, [priorityTasksData]);
    // Keep pagination metadata stable across refetches so the page footer doesn't reset
    // mid-navigation. Rows themselves stay strict on `data` (cleared by the container's
    // hasSettled gate on context change).
    const prevPriorityTasksData = (_b = previousData === null || previousData === void 0 ? void 0 : previousData.catalog) === null || _b === void 0 ? void 0 : _b.priorityTasks;
    const pageInfo = (_c = priorityTasksData === null || priorityTasksData === void 0 ? void 0 : priorityTasksData.pageInfo) !== null && _c !== void 0 ? _c : prevPriorityTasksData === null || prevPriorityTasksData === void 0 ? void 0 : prevPriorityTasksData.pageInfo;
    const totalCount = (_d = priorityTasksData === null || priorityTasksData === void 0 ? void 0 : priorityTasksData.totalCount) !== null && _d !== void 0 ? _d : prevPriorityTasksData === null || prevPriorityTasksData === void 0 ? void 0 : prevPriorityTasksData.totalCount;
    // Treat "waiting for required IDs" the same as loading to avoid a brief no-data state.
    const isLoading = shouldSkip || (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    const priorityTasks = (0, react_1.useMemo)(() => { var _a; return (_a = edges.map(({ node }) => node)) !== null && _a !== void 0 ? _a : []; }, [edges]);
    return {
        data: priorityTasks,
        isLoading,
        error,
        refetch,
        pageInfo,
        totalCount,
    };
};
exports.useGetHLQATasks = useGetHLQATasks;
